import {
  type CSSProperties,
  type ReactElement,
  type ReactNode,
  cloneElement,
} from 'react';
import { Footer } from './Footer';
import { Header } from './Header';

export interface DialogProps {
  draggable?: boolean;
  children?: ReactNode;
  header?: ReactElement;
  footer?: ReactElement;
  onClose?: () => void;
  onSubmit?: () => void;
  title?: string;
  width?: string | number;
  height?: string | number;
  className?: string;
  dialogStyle?: CSSProperties;
  contentClassName?: string;
}

export const Dialog = ({
  children,
  header = <Header />,
  footer = <Footer />,
  onClose = () => false,
  onSubmit = () => false,
  title,
  contentClassName,
  dialogStyle = {},
  width,
  height,
}: DialogProps) => (
  <div
    className="p-5 shadow-ds-lg rounded-md w-ds-dialog bg-white flex flex-col"
    style={{ width, height, ...dialogStyle }}
  >
    {cloneElement(header, { onClose, title })}
    <div className={contentClassName}>{children}</div>
    {cloneElement(footer, { onClose, onSubmit })}
  </div>
);
